module.exports = __webpack_public_path__ + "static/media/do2.42cc6cba.png";